import React, { Fragment, useState, useEffect } from "react";
import { Card, CardBody, Row } from "reactstrap";
import CarContent from "./CarContent";
const CarDetails = ({
  carObj,
}) => {




  return (
    <Fragment>
      <Card className="driver-details">
        <CardBody>
          <Row className="driver-info">
            <div className="driver-content">
              <CarContent carObj={carObj} />
            </div>
          </Row>
        </CardBody>
      </Card>
    </Fragment>
  );
};

export default CarDetails;
